import { VENDOR_PATHS } from './vendor-manifest';

export const buildCustomDashboardCsp = (origin = window.location.origin): string =>
  [
    "default-src 'none'",
    "base-uri 'none'",
    `script-src 'unsafe-inline' ${VENDOR_PATHS.map((path) => `${origin}${path}`).join(' ')}`,
    "style-src 'unsafe-inline'",
    `font-src ${origin}/vendor/ data:`,
    'img-src data:',
    "connect-src 'none'",
    "form-action 'none'",
  ].join('; ');

export const createSandboxedIframe = (srcdoc: string): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('sandbox', 'allow-scripts');
  iframe.srcdoc = srcdoc;
  return iframe;
};

export const watchIframeNavigation = (
  iframe: HTMLIFrameElement,
  onNavigation: () => void,
): (() => void) => {
  // srcdoc の同期scriptが初回load前に遷移すると、その遷移先のloadを初期描画と区別できない。
  // BE 検証（upload_validation）は navigation に使える経路（外部 URL・form / base /
  // meta refresh 等）を拒否するが、location 代入等の navigation 自体は拒否できない。
  // これは受容済みの残余リスク（docs/features/custom-dashboard-security.md。挙動の固定は
  // custom-dashboard.browser.test.ts）。
  let initialLoadCompleted = false;
  const handleLoad = () => {
    if (!initialLoadCompleted) {
      initialLoadCompleted = true;
      return;
    }
    iframe.remove();
    onNavigation();
  };
  iframe.addEventListener('load', handleLoad);
  return () => iframe.removeEventListener('load', handleLoad);
};
